<template>
	<div class="pages_intro">
		<section class="link-card-section">
			<div class="card-contents">
				<div class="link-title">
					{{ linkTitle }}
				</div>
				<div class="introduction">
					<p v-html="introduction"></p>
				</div>
				<slot />
			</div>
		</section>
	</div>
</template>

<script>
// @ is an alias to /src
export default {
	name: 'PagesIntro',
	props: {
		linkTitle: String,
		introduction: String,
	},
};
</script>

<style lang="scss" scoped>
.pages_intro {
	&:nth-child(even) {
		.link-title {
			@media print, screen and (min-width: 1161px) {
				right: 2%;
				left: unset;
			}
		}
	}
}
.link-card-section {
	margin: 0 auto;
	width: 100%;
	max-width: 1200px;
	position: relative;
	height: 100%;
	padding-top: 80px;
	margin-bottom: 150px;
	@media print, screen and (max-width: 1160px) {
		max-width: 90%;
		border: 2px solid #543193;
		padding-top: 50px;
	}
	&:before {
		@media print, screen and (min-width: 1161px) {
			content: '';
			width: 96%;
			height: 2px;
			background-color: #543193;
			position: absolute;
			z-index: 1;
			top: 0;
			right: 2%;
			margin: auto;
		}
	}
	&:after {
		@media print, screen and (min-width: 1161px) {
			content: '';
			width: 96%;
			height: 2px;
			background-color: #543193;
			position: absolute;
			z-index: 1;
			bottom: 0;
			right: 2%;
			margin: auto;
		}
	}
}
.card-contents {
	margin-bottom: 30px;
	@media print, screen and (min-width: 1161px) {
		&:before {
			content: '';
			width: 2px;
			height: 100%;
			background-color: #543193;
			position: absolute;
			z-index: 1;
			top: 0;
			right: 2%;
			margin: auto;
		}
	}
	@media print, screen and (min-width: 1161px) {
		&:after {
			content: '';
			width: 2px;
			height: 100%;
			background-color: #543193;
			position: absolute;
			z-index: 1;
			left: 2%;
			top: 0;
			margin: auto;
		}
	}
}
.link-title {
	font-family: 'Noto Serif JP';
	background-color: #543193;
	color: #fff;
	display: inline-block;
	position: absolute;
	left: 2%;
	top: 0;
	padding: 0.5em 2.5em;
	font-size: 18px;
	@media print, screen and (max-width: 1160px) {
		left: 0;
	}
}
.introduction {
	text-align: center;
	font-family: 'Noto Serif JP';
	font-size: 16px;
	line-height: 2.5em;
	margin-bottom: 50px;
	p {
		line-height: inherit;
		margin: 0;
		@media print, screen and (max-width: 1160px) {
			font-size: 15px;
			line-height: calc(73 / 29);
		}
	}
	@media print, screen and (max-width: 1160px) {
		margin: 30px;
		text-align: center;
	}
	@media print, screen and (max-width: 520px) {
		text-align: left;
	}
}
</style>
